import { render, staticRenderFns } from "./iframe-head.vue?vue&type=template&id=85d2987e&scoped=true"
import script from "./iframe-head.vue?vue&type=script&lang=js"
export * from "./iframe-head.vue?vue&type=script&lang=js"
import style0 from "./iframe-head.vue?vue&type=style&index=0&id=85d2987e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d2987e",
  null
  
)

export default component.exports